import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchKultFetchStart,
  fetchKultFetchSuccess,
  fetchKultFetchFailure,
  fetchHotlistStart,
  fetchHotlistFailure,
  fetchHotlistSuccess,
  fetchCandidatesStart,
  fetchCandidatesFailure,
  fetchCandidatesSuccess,
  fetchTotalCountFailure,
  fetchTotalCountSuccess,
  fetchTotalCountStart,
  addCandidateStart,
  addCandidateFailure,
  addCandidateSuccess,
  updateCandidateStart,
  updateCandidateSuccess,
  updateCandidateFailure,
  uploadDocumentStart,
  uploadDocumentFailure,
  uploadDocumentSuccess,
  clearUploads,
  fetchUsersSuccess,
  fetchUsersFailure,
  fetchUsersStart,
  getTotalUserCountSuccess,
  getTotalUserCountFailure,
  getTotalUserCountStart,
  addJobContactSuccess,
  addJobContactFailure,
  addJobContactsStart,
  fetchCompanyContactSuccess,
  fetchCompanyContactFilure,
  fetchCompanyContactStart,
  addSubmissionFailure,
  addSubmissionSuccess,
  addSubmissionStart,
  fetchSubmissionStart,
  fetchSubmissionSuccess,
  fetchSubmissionFailure,
  addInterviewSuccess,
  addInterviewFailure,
  addInterviewStart,
  fetchInterviewSuccess,
  fetchInterviewFailure,
  fetchInterviewStart,
  getCandidateAnalyzeSuccess,
  getCandidateAnalyzeFailure,
  getCandidateAnalyzeStart,
  fetchAllCandidatesStart,
  fetchAllCandidatesSuccess,
  fetchAllCandidatesFailure,
  fetchCandidateVersioSuccess,
  fetchCandidateVersionStart,
  fetchJobCandidateSuccess,
  fetchJobCandidateFailure,
  fetchJobCandidateStart,
  getRecruiterAssignedSuccess,
  getRecruiterAssignedFailure,
  getRecruiterAssignedStart,
  getRecruitersUiidSuccess,
  getRecruitersUiidFailure,
  getRecruitersUiidStart,
  getGlobalCandidateSuccess,
  getGlobaleCandidateFailure,
  getGlobalCandidateStart,
  openaiIntgrateAccessStart,
  openaiIntgrateAccessSuccess,
  openaiIntgrateAccessFailure,
  getApolloIntgrateAccessStart,
  getApolloIntgrateAccessSuccess,
  getApolloIntgrateAccessFailure,
  getTotalInterviewCountSuccess,
  getTotalInterviewCountFailure,
  getTotalInterviewCountStart,
  getTotalPlacementCountFailure,
  getTotalPlacementCountSuccess,
  getTotalPlacementCountStart,
  openaiOptimizationIntgrateAccessStart,
  openaiOptimizationIntgrateAccessSuccess,
  openaiOptimizationIntgrateAccessFailure,
  getValidEmailIntgrateAccessStart,
  getValidEmailIntgrateAccessSuccess,
  getValidEmailIntgrateAccessFailure,
  getAssignedCandidateSuccess,
  getAssignedCandidateStart,
  getAssignedCandidateFailure,
  getUnAssignedCandidateSuccess,
  getUnAssignedCandidateFailure,
  getUnAssignedCandidateStart,
  getDashboardCountsSuccess,
  getDashboardCountsFailure,
  getDashboardCountsStart,
  openaiDraftIntgrateAccessSuccess,
  openaiDraftIntgrateAccessFailure,
  openaiDraftIntgrateAccessStart
} from "./benchSalesSlice";
import {
  fetchCandidateApi,
  fetchHotlistApi,
  fetchKultFetchApi,
  fetchTotalCountApi,
  addCandidateApi,
  updateCandidateApi,
  uploadDocumentApi,
  fetchUsersApi,
  getTotalUserCountApi,
  addJobContactApi,
  fetchCompanyContactApi,
  addSubmissionDetailsApi,
  fetchSubmissionDetailsApi,
  addInterviewDetailsApi,
  fetchInterviewDetailsApi,
  handleAnalyzeApi,
  //fetchCandidateVersinApi,
  fetchCandidateVersionApi,
  getRecruiterAssignedCandidatedApi,
  getRecruitersUiidApi,
  fetchIntegrationAccess,
  getTotalMainCountApi,
  getAssignedCandidateApi,
} from "./benchSalesApi";
import { showToast } from "../../../../components";
import { take } from "lodash";

function* fetchKultFetchWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchKultFetchApi, params);

    if (response?.data) {
      const kultData = response.data.data || [];
      yield put(fetchKultFetchSuccess({ data: kultData }));

      if (onSuccess) onSuccess(kultData);
    } else {
      yield put(fetchKultFetchFailure("Failed to fetch Kult Fetch data"));
    }
  } catch (error) {
    yield put(fetchKultFetchFailure(error.message));
    showToast(
      error.message || "Failed to fetch Kult Fetch data",
      "error",
      2000
    );
  }
}

function* fetchHotlistWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchHotlistApi, params);
    if (response?.data) {
      const hotlistData = response.data.data || [];
      yield put(fetchHotlistSuccess({ data: hotlistData }));
      if (onSuccess) onSuccess(hotlistData);
    } else {
      yield put(fetchHotlistFailure("Failed to fetch Hotlist data"));
    }
  } catch (error) {
    yield put(fetchHotlistFailure(error.message));
  }
}

export function* watchKultFetch() {
  yield takeLatest(fetchKultFetchStart.type, fetchKultFetchWorker);
  yield takeLatest(fetchHotlistStart.type, fetchHotlistWorker);
}

function* fetchCandidatesWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchCandidateApi, params);

    if (response?.data) {
      const candidatesData = response.data.data || [];
      yield put(fetchCandidatesSuccess({ data: candidatesData }));
      if (onSuccess) onSuccess(candidatesData);
    } else {
      yield put(fetchCandidatesSuccess({ data: [] }));
      yield put(fetchCandidatesFailure("Failed to fetch candidates"));
    }
  } catch (error) {
    yield put(fetchCandidatesFailure(error.message));
  }
}

function* fetchAllCandidatesWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchCandidateApi, params);

    if (response?.data) {
      const candidatesData = response.data.data || [];
      yield put(fetchAllCandidatesSuccess({ data: candidatesData }));
      if (onSuccess) onSuccess(candidatesData);
    } else {
      console.error("error occuered while fetching all candidates.");
      // yield put(fetchCandidatesFailure("Failed to fetch candidates"));
      yield put(fetchAllCandidatesFailure("Failed to fetch candidates"));
    }
  } catch (error) {
    yield put(fetchAllCandidatesFailure("Failed to fetch candidates"));
    console.error(
      "error occuered while fetching all candidates.",
      error.message
    );
  }
}

function* fetchAllCandidateVersionWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchCandidateVersionApi, params);
    if (response?.data) {
      const candidateVersionData = response.data.data || [];
      yield put(fetchCandidateVersioSuccess({ data: candidateVersionData }));
      if (onSuccess) onSuccess(candidateVersionData);
    } else {
      console.error("error occuered while fetching all  candidates versions.");
    }
  } catch (error) {
    console.error(
      "error occuered while fetching all candidates.",
      error.message
    );
  }
}

function* fetchTotalCountWorker(action) {
  try {
    const response = yield call(fetchTotalCountApi, action.payload);
    const { total, totalSubmissions, totalInterviews, totalPlacements, assignedCandidate, unassignedCandidate, onlyOnProjectCount, onlyOnBenchCount, bothCount } =
      response?.data?.data;

    yield put(
      fetchTotalCountSuccess({
        total,
        totalSubmissions,
        totalInterviews,
        totalPlacements,
        assignedCandidate,
        unassignedCandidate,
        onlyOnProjectCount,
        onlyOnBenchCount,
        bothCount
      })
    );
  } catch (error) {
    yield put(fetchTotalCountFailure(error.message));
  }
}

function* addCandidateWorker(action) {
  try {
    const { onSuccess, onError, ...payload } = action.payload;

    const response = yield call(addCandidateApi, payload);
    const newCandidate = response?.data?.data;

    yield put(addCandidateSuccess(newCandidate));
    if (onSuccess) onSuccess(newCandidate);
  } catch (error) {
    yield put(addCandidateFailure(error.message));
    if (onError) onError(error);
  }
}

function* updateCandidateWorker(action) {
  try {
    const { uiid, payload, onSuccess, onError } = action.payload;

    const response = yield call(updateCandidateApi, uiid, payload);
    const updatedCandidate = response?.data?.data;

    yield put(updateCandidateSuccess(updatedCandidate));
    if (onSuccess) onSuccess(updatedCandidate);
  } catch (error) {
    yield put(updateCandidateFailure(error.message));
    if (onError) onError(error);
  }
}

function* uploadDocumentWorker(action) {
  try {
    const { formData, params, onSuccess, onError } = action.payload;

    const response = yield call(uploadDocumentApi, formData, params);
    const uploadedFiles = response?.data?.data || [];

    yield put(uploadDocumentSuccess(uploadedFiles));

    if (onSuccess) onSuccess(uploadedFiles);
  } catch (error) {
    yield put(uploadDocumentFailure(error.message));
    if (onError) onError(error);
  }
}
function* fetchUsersWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchUsersApi, params);

    if (response?.data) {
      const usersData = response.data.data || [];
      yield put(fetchUsersSuccess({ data: usersData }));
      if (onSuccess) onSuccess(usersData);
    } else {
      yield put(fetchUsersSuccess({ data: [] }));
      yield put(fetchUsersFailure("Failed to fetch users"));
    }
  } catch (error) {
    yield put(fetchUsersFailure(error.message));
  }
}

function* getTotalUserCountWorker(action) {
  try {
    const response = yield call(getTotalUserCountApi, action.payload);
    const total = response?.data.data || 0;
    yield put(getTotalUserCountSuccess(total));
  } catch (error) {
    yield put(getTotalUserCountFailure(error.message));
  }
}

function* addJobContactsWorker(action) {
  try {
    const response = yield call(addJobContactApi, action.payload);
    const total = response?.data.data || 0;
    yield put(addJobContactSuccess(total));
  } catch (error) {
    yield put(addJobContactFailure(error.message));
  }
}

function* fetchCompanyContactsWorker(action) {
  try {
    const response = yield call(fetchCompanyContactApi, action.payload);

    const raw = response?.data?.data || [];
    const contactsOnly = raw[0]?.contacts || [];

    if (Array.isArray(raw) && raw.length > 0) {
      yield put(fetchCompanyContactSuccess({ data: raw }));
    } else {
      yield put(fetchCompanyContactSuccess({ data: [] }));
    }

  } catch (error) {
    yield put(fetchCompanyContactSuccess({ data: [] }));
    yield put(fetchCompanyContactFilure(error.message));
  }
}

function* addSubmissionWorker(action) {
  try {
    const response = yield call(addSubmissionDetailsApi, action.payload);
    const data = response?.data?.data;
    if (response.success) {
      showToast("Data Saved Successfully", "success");
      yield put(addSubmissionSuccess(data));
    } else {
      showToast(response.error, "error");
    }
  } catch (error) {
    console.error("Submission Saga Error:", error);

    yield put(addSubmissionFailure(msg));
  }
}

function* fetchSubmissionWorker(action) {
  try {
    const response = yield call(fetchSubmissionDetailsApi, action.payload);
    const data = response?.data?.data;
    yield put(fetchSubmissionSuccess(data));
  } catch (error) {
    yield put(fetchSubmissionFailure(msg));
  }
}

function* addInterviewWorker(action) {
  try {
    const response = yield call(addInterviewDetailsApi, action.payload);
    const data = response?.data?.data;
    if (response.success) {
      showToast("Data Saved Successfully", "success");
      yield put(addInterviewSuccess(data));
    } else {
      showToast(response.error, "error");
    }
  } catch (error) {
    console.error("Inerview Saga Error:", error);

    yield put(addInterviewFailure(msg));
  }
}

function* fetchInterviewWorker(action) {
  try {
    const response = yield call(fetchInterviewDetailsApi, action.payload);
    const data = response?.data?.data;
    yield put(fetchInterviewSuccess(data));
  } catch (error) {
    yield put(fetchInterviewFailure(msg));
  }
}
function* getCandidateAnalyzeWorker(action) {
  try {
    const response = yield call(handleAnalyzeApi, action.payload);
    const data = response?.data?.data;

    yield put(getCandidateAnalyzeSuccess(data));
  } catch (error) {
    yield put(getCandidateAnalyzeFailure(error.message));
  }
}

function* fetchJobCandidateWorker(action) {
  try {
    const response = yield call(fetchCandidateApi, action.payload);
    const data = response?.data?.data;

    yield put(fetchJobCandidateSuccess(data[0]));
  } catch (error) {
    yield put(fetchJobCandidateFailure(error.message));
  }
}

function* fetchRecruiterAssignedWorker(action) {
  try {
    const response = yield call(
      getRecruiterAssignedCandidatedApi,
      action.payload
    );
    const data = response?.data?.data;

    yield put(getRecruiterAssignedSuccess(data));
  } catch (error) {
    yield put(getRecruiterAssignedFailure(error.message));
  }
}

function* getRecruitesUiidWorker(action) {
  try {
    const response = yield call(getRecruitersUiidApi, action.payload);
    const data = response?.data?.data;
    yield put(getRecruitersUiidSuccess(data));

    // yield put(getRecr(data));
  } catch (error) {
    yield put(getRecruitersUiidFailure(error.message));
  }
}



function* getGlobalCandidatesWorker(action) {
  try {
    const response = yield call(fetchTotalCountApi, action.payload);
    const data = response?.data?.data;

    yield put(getGlobalCandidateSuccess(data));

    // yield put(getRecr(data));
  } catch (error) {
    yield put(getGlobaleCandidateFailure(error.message));
  }
}

function* fetchIntegrationAccessOpenAi(action) {
  try {
    const response = yield call(fetchIntegrationAccess, action.payload);
    console.log("OpenAI Integration Access Response:", response);
    const data = response?.data?.data;
    yield put(openaiIntgrateAccessSuccess(data));
  } catch (error) {
    yield put(openaiIntgrateAccessFailure(error.message));
  }
}

function* fetchIntegrationAccessApollo(action) {
  try {
    const response = yield call(fetchIntegrationAccess, action.payload);
    const data = response?.data?.data;
    yield put(getApolloIntgrateAccessSuccess(data));
  } catch (error) {
    yield put(getApolloIntgrateAccessFailure(error.message));
  }
}




function* fetchTotalMainInterviewCountWorker(action) {
  try {
    const response = yield call(getTotalMainCountApi, action.payload);
    const data = response?.data?.data;

    yield put(getTotalInterviewCountSuccess(data));
  } catch (error) {
    yield put(getTotalInterviewCountFailure(error.message));
  }
}
 

function* fetchTotalMainPlacementCountWorker(action) {
  try {
    const response = yield call(getTotalMainCountApi, action.payload);
    const data = response?.data?.data;

    yield put(getTotalPlacementCountSuccess(data[0]));
  } catch (error) {
    yield put(getTotalPlacementCountFailure(error.message));
  }
}


function* fetchIntegrationAccessOpenAiOptimization(action) {
  try {
    const response = yield call(fetchIntegrationAccess, action.payload);
    const data = response?.data?.data;
    yield put(openaiOptimizationIntgrateAccessSuccess(data));
  } catch (error) {
    yield put(openaiOptimizationIntgrateAccessFailure(error.message));
  }
} 


function* fetchIntegrationAccessDraft(action) {
  try {
  const response = yield call(fetchIntegrationAccess, action.payload);
    const data = response?.data?.data;
    yield put(openaiDraftIntgrateAccessSuccess(data));
  } catch (error) {
    yield put(openaiDraftIntgrateAccessFailure(error.message));
  }
}

function* fetchIntegrationAccessValidEmail(action) {
  try {
    const response = yield call(fetchIntegrationAccess, action.payload);
    const data = response?.data?.data;
    yield put(getValidEmailIntgrateAccessSuccess(data));
  } catch (error) {
    yield put(getValidEmailIntgrateAccessFailure(error.message));
  }
}


function* fetchAssignedCandidate(action) {
  try {
    const response = yield call(getAssignedCandidateApi, action.payload);
    const data = response?.data?.data;
    yield put(getAssignedCandidateSuccess(data));
  } catch (error) {
    yield put(getAssignedCandidateFailure(error.message));
  }
} 


function* fetchUnAssignedCandidate(action) {
  try {
    const response = yield call(getAssignedCandidateApi, action.payload);
    const data = response?.data?.data;
    yield put(getUnAssignedCandidateSuccess(data));
  } catch (error) {
    yield put(getUnAssignedCandidateFailure(error.message));
  }
}
function* fetchDashboardCounts(action) {
  try {
    const response = yield call(getAssignedCandidateApi, action.payload);
    const data = response?.data?.data;
    console.log(data)
    yield put(getDashboardCountsSuccess(data[0]));
  } catch (error) {
    yield put(getDashboardCountsFailure(error.message));
  }
}

export function* watchBenchSales() {
  yield takeLatest(getTotalPlacementCountStart.type, fetchTotalMainPlacementCountWorker);
  yield takeLatest(getTotalInterviewCountStart.type, fetchTotalMainInterviewCountWorker);
  yield takeLatest(fetchKultFetchStart.type, fetchKultFetchWorker);
  yield takeLatest(fetchHotlistStart.type, fetchHotlistWorker);
  yield takeLatest(fetchCandidatesStart.type, fetchCandidatesWorker);
  yield takeLatest(fetchTotalCountStart.type, fetchTotalCountWorker);
  yield takeLatest(addCandidateStart.type, addCandidateWorker);
  yield takeLatest(updateCandidateStart.type, updateCandidateWorker);

  yield takeLatest(uploadDocumentStart.type, uploadDocumentWorker);
  yield takeLatest(fetchUsersStart.type, fetchUsersWorker);
  yield takeLatest(getTotalUserCountStart.type, getTotalUserCountWorker);
  yield takeLatest(addJobContactsStart.type, addJobContactsWorker);
  yield takeLatest(fetchCompanyContactStart.type, fetchCompanyContactsWorker);
  yield takeLatest(addSubmissionStart.type, addSubmissionWorker);
  yield takeLatest(fetchSubmissionStart.type, fetchSubmissionWorker);
  yield takeLatest(addInterviewStart.type, addInterviewWorker);
  yield takeLatest(fetchInterviewStart.type, fetchInterviewWorker);
  yield takeLatest(getCandidateAnalyzeStart.type, getCandidateAnalyzeWorker);
  yield takeLatest(fetchAllCandidatesStart.type, fetchAllCandidatesWorker);
  yield takeLatest(
    fetchCandidateVersionStart.type,
    fetchAllCandidateVersionWorker
  );
  yield takeLatest(fetchJobCandidateStart.type, fetchJobCandidateWorker);
  yield takeLatest(
    getRecruiterAssignedStart.type,
    fetchRecruiterAssignedWorker
  );
  yield takeLatest(getRecruitersUiidStart.type, getRecruitesUiidWorker);
  yield takeLatest(getGlobalCandidateStart.type, getGlobalCandidatesWorker);
  yield takeLatest(openaiIntgrateAccessStart.type, fetchIntegrationAccessOpenAi);
  yield takeLatest(getApolloIntgrateAccessStart.type, fetchIntegrationAccessApollo);
  yield takeLatest(openaiOptimizationIntgrateAccessStart.type, fetchIntegrationAccessOpenAiOptimization);
    yield takeLatest(openaiDraftIntgrateAccessStart.type, fetchIntegrationAccessDraft);
  yield takeLatest(getValidEmailIntgrateAccessStart.type, fetchIntegrationAccessValidEmail);  
    yield takeLatest(getAssignedCandidateStart.type,fetchAssignedCandidate); 
    yield takeLatest(getUnAssignedCandidateStart.type,fetchUnAssignedCandidate); 
    yield takeLatest(getDashboardCountsStart.type,fetchDashboardCounts); 


  
}
